import WechatApi from 'api/WechatApi';

const craeteShareConfig = function(config) {
  const { title, link, imageUrl, desc, cb } = config || {} ;
  return {
    title: title, // 分享标题
    link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: imageUrl,
    desc: desc,
    success: function() {
      console.log('分享成功');
      if (cb) {
        cb();
      }
    },
    fail: function() {
      console.log('分享失败');
    },
    cancel: function() {
      console.log('用户取消事件');
    }
  };
};

/**
 * 微信分享
 * @param title
 * @param link
 * @param imageUrl
 * @param cb
 * @param desc
 * @param shareUrlParams
 */
const enjory = function(type, config) {
  // type 为 share为打开并配置分享，否则为禁用分享
  const shareMessage = craeteShareConfig(config);
  WechatApi.getWechatConfig({
    url: location.href.split('#')[0]
  }).then(function(res) {
    if (res.code === 20000) {
      wx.config({
        debug: false,
        appId: res.data.appId,
        timestamp: res.data.timestamp,
        nonceStr: res.data.nonceStr,
        signature: res.data.signature,
        jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'showAllNonBaseMenuItem', 'hideAllNonBaseMenuItem']
      });
      wx.ready(function () {
        console.log(type)
        if (type === "share") {
          wx.onMenuShareAppMessage(shareMessage); // 分享给朋友
          wx.onMenuShareTimeline(shareMessage); // 分享到朋友圈
          wx.showAllNonBaseMenuItem()
        } else {
          wx.hideAllNonBaseMenuItem()
        }
      });
      wx.error(function (res) {
        console.log('验证失败返回的信息:', res);
      });
    } else {
      console.log(res);
    }
  }).catch(function (error) {
    console.log(error);
  });
};

// 微信支付
function onBridgeReady(data, cb, errorCb) {
  WeixinJSBridge.invoke(
    'getBrandWCPayRequest', {
      appId: data.app_id, // 公众号名称，由商户传入
      timeStamp: data.time_stamp, // 时间戳，自1970年以来的秒数
      nonceStr: data.nonce_str, // 随机串
      package: data.package,
      signType: data.sign_type, // 微信签名方式：
      paySign: data.sign // 微信签名
    },
    function (res) {
      if (res.err_msg == 'get_brand_wcpay_request:ok') {
        // 使用以上方式判断前端返回,微信团队郑重提示：
        // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        cb();
      } else {
        errorCb();
      }
    });
}

const wexinPay = function (data, cb, errorCb) {
  if (typeof WeixinJSBridge == 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', function () {
        onBridgeReady(data, cb, errorCb);
      }, false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', function () {
        onBridgeReady(data, cb, errorCb);
      });
      document.attachEvent('onWeixinJSBridgeReady', function () {
        onBridgeReady(data, cb, errorCb);
      });
    }
  } else {
    onBridgeReady(data, cb, errorCb);
  }
};
const isMobile = () => (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent));

const updateShareConfig = function (config) {
  const message = craeteShareConfig(config);
  wx.onMenuShareAppMessage(message);
  wx.onMenuShareTimeline(message);
};

export {
  updateShareConfig,
  enjory,
  wexinPay,
  isMobile
};
